import React from "react";
import { Dropdown, Icon } from "semantic-ui-react";
import cx from "classnames";

import styles from "./sort_filter.module.scss";

export default function SortFilter({
  sort,
  order,
  onSortChange,
  onOrderChange,
  options,
  className,
}) {
  return (
    <div className={cx(styles.sort)}>
      <span className={cx(styles.label)}> Sort by:  {" "}
      <Icon
        name="arrow up"
        className={cx(styles.icon, order === "ASC" ? styles.active : "")}
        onClick={() => onOrderChange("ASC")}
      />
      <Icon
        name="arrow down"
        className={cx(styles.icon, order === "DESC" ? styles.active : "")}
        onClick={() => onOrderChange("DESC")}
      />
      </span>

      <Dropdown
        direction="left"
        value={sort}
        onChange={(e, data) => onSortChange(data.value)}
        options={options}
        className={cx(styles.text)}
      />
    </div>
  );
}
